<template>
	<div class="modal-card addUser">
		<div class="modal-card-head">
			<p class="modal-card-title">{{ Operation }} Opportunity</p>
		</div>
		<div class="modal-card-body">
			<div id="opportunityModal" class="columns">
				<div class="column">
					<b-field label="Job Title">
						<b-input placeholder="Job Title" type="text" v-model="opp.Title"></b-input>
					</b-field>

					<b-field label="Hiring Company">
						<b-input placeholder="Hiring Company" type="text" v-model="opp.Company"></b-input>
					</b-field>

					<b-field label="Search Firm">
						<b-input placeholder="Search Firm" type="text" v-model="opp.Firm"></b-input>
					</b-field>

					<b-field label="Email">
						<b-input placeholder="Email" type="text" v-model="opp.Link"></b-input>
					</b-field>

				</div>
				<div class="column">

					<b-field label="Job Posted Date">
						<b-datepicker placeholder="Please select the posted date" v-model="opp.PostDate"></b-datepicker>
					</b-field>

					<b-field label="Expiration Date">
						<b-datepicker placeholder="Please select the expiration date" v-model="opp.Expiration"></b-datepicker>
					</b-field>

					<b-field label="Select Industries">
						<b-taginput placeholder="Select Industries"
									autocomplete
									type="is-primary"
									field="Name"
									v-model="opp.IndustriesSelect"
									:data="filteredIndustries"
									@typing="filterIndustries"
									open-on-focus>
						</b-taginput>
					</b-field>

					<b-field label="Select Functions">
						<b-taginput placeholder="Select Functions"
									autocomplete
									type="is-primary"
									field="Name"
									v-model="opp.FunctionsSelect"
									:data="filteredFunctions"
									@typing="filterFunctions"
									open-on-focus>
						</b-taginput>
					</b-field>

					<b-field label="Select Countries">
						<b-taginput placeholder="Select Countries"
									autocomplete
									type="is-primary"
									field="Name"
									v-model="opp.CountriesSelect"
									:data="filteredCountries"
									@typing="filterCountries"
									open-on-focus>
						</b-taginput>
					</b-field>
				</div>
				<div class="column">
					<b-field label="Job Description">
						<b-input placeholder="Job Description" type="textarea" v-model="opp.Description"></b-input>
					</b-field>

					<b-field label="How to apply">
						<b-input placeholder="How to apply" type="textarea" v-model="opp.Instructions"></b-input>
					</b-field>
				</div>
			</div>
		</div>
		<div class="modal-card-foot">
			<b-button class="is-primary" :disabled="disablePreview" @click="preview">Preview and Submit</b-button>
			<b-button class="is-grey" @click="$parent.close()">Cancel</b-button>
		</div>
	</div>
</template>

<script>
	import previewOpp from "@/components/modals/previewOpp.vue";
	export default {
		props: {
			Opportunity: Object
		},
		data() {
			return {
				opp: {},
				filteredIndustries: [],
				filteredCountries: [],
				filteredFunctions: [],
				options: {}
			}
		},
		computed: {
			Operation() {
				if (this.Opportunity.Title)
					return "Edit";
				else
					return "Add";
			},
			disablePreview() {
				if (this.opp.PostDate &&
					this.opp.Expiration &&
					this.opp.FunctionsSelect &&
					this.opp.IndustriesSelect &&
					this.opp.CountriesSelect &&
					this.opp.Company &&
					this.opp.Instructions &&
					this.opp.Title &&
					this.opp.Firm &&
					this.opp.Link) {
					return false;
				}
				else {
					if (this.Operation == "Edit") {
						return false;
					} else {
						return true;
					}
				}
			}
		},
		methods: {
			preview() {
				this.$buefy.modal.open({
					parent: this,
					component: previewOpp,
					hasModalCard: true,
					canCancel: false,
					props: {
						Opp: this.opp
					},
					events: {
						'saved': (opp) => {
							this.$emit('saved', opp);
							this.$emit('close');
						}
					}
				})
			},
			filterIndustries(text) {
				this.filteredIndustries = this.options.Industries.filter((option) => {
					return option
						.toString()
						.toLowerCase()
						.indexOf(text.toLowerCase()) >= 0;
				})
			},
			filterCountries(text) {
				this.filteredCountries = this.options.Countries.filter((option) => {
					return option
						.toString()
						.toLowerCase()
						.indexOf(text.toLowerCase()) >= 0;
				})
			},
			filterFunctions(text) {
				this.filteredFunctions = this.options.Functions.filter((option) => {
					return option
						.toString()
						.toLowerCase()
						.indexOf(text.toLowerCase()) >= 0;
				})
			},
		},
		async created() {
			this.opp = this.Opportunity;
			if (this.opp.Id) {
				this.opp.PostDate = new Date(this.opp.PubDate);
				this.opp.Expiration = new Date(this.opp.Expiration);
				this.opp.FunctionsSelect = this.opp.JobFunction.split(" | ");
				this.opp.IndustriesSelect = this.opp.JobIndustry.split(" | ");
				this.opp.CountriesSelect = this.opp.JobLocationCountry.split(" | ");
				this.opp.Company = this.opp.SearchFirmClientOrganizationName;
				this.opp.Instructions = this.opp.SearchFirmClientOrganizationDescription;
			}

			this.$http.get("api/opportunity/form")
				.then(resp => {
					this.options = resp.data;
					this.filteredFunctions = this.options.Functions;
					this.filteredCountries = this.options.Countries;
					this.filteredIndustries = this.options.Industries;
					if (this.Operation == "Add") {
						this.opp.Firm = this.options.FirmName;
					}
					else {
						this.opp.Firm = this.opp.SearchFirmName;
					}
				}).catch(err => {
					console.log(err);
				})
		}
	}
</script>

<style>


	.addOpp {
		overflow: visible !important;
	}

	#opportunityModal .dropdown-menu {
		z-index: 9999;
		overflow: visible;
	}
</style>
